import { gql } from '@apollo/client'
import React from 'react'

import { formsClient } from '../../../utils/apollo/api'
import { useQuery } from '../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../components/helpers/StatePresenter'

const QUERY = gql`
  query Form($id: ID) {
    form(id: $id) {
      id
      name
      description
      access
      repliesCount
      shareCode
      placeType
      checklistId
      checklist {
        id
        name
      }
    }
  }
`

const Context = React.createContext([])
const { Provider } = Context
export const useFormState = () => React.useContext(Context)
export const useForm = () => useFormState()?.form

const FormLoader = ({ children, id, onLoad }) => {
  const idRef = React.useRef(id)

  const { data, ...state } = useQuery(QUERY, {
    variables: { id: idRef.current },
    client: formsClient,
    fetchPolicy: 'no-cache',
    onCompleted: data => data?.form && onLoad && onLoad(data.form)
  })

  if (!id) return children

  return (
    <StatePresenter {...state}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default FormLoader
